import React, { useEffect, useState } from 'react';
import UrlPattern from 'url-pattern';
import { useLocation, useNavigate } from 'react-router-dom';
import { Text, TabList, Tabs, TabsProps, Tab } from '@chakra-ui/react';
import { Route } from 'app/routing/routesConfig';
import { GenericObject } from 'types/generic.types';

export interface NavTabsProps extends Partial<TabsProps> {
  guid?: string | GenericObject<string>;
  routes: Route[];
  counts?: GenericObject<number>;
  className?: string;
}

const getActiveTab = (
  pathname: string,
  routes: Route[],
  guid?: string | GenericObject<string>
) => {
  const processedUrls = routes.map((route) => {
    if (guid) {
      return new UrlPattern(route.path).stringify(
        typeof guid === 'object' ? guid : { guid }
      );
    }
    return route.path;
  });

  const activeRoute =
    processedUrls.find((url) => pathname.includes(url)) || processedUrls[0];
  return activeRoute
    ? processedUrls.findIndex((url) => url === activeRoute)
    : 0;
};

export const NavTabs: React.FC<NavTabsProps> = ({
  guid,
  routes,
  counts,
  ...rest
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(
    getActiveTab(location.pathname, routes, guid)
  );

  useEffect(() => {
    setActiveTab(
      getActiveTab(`${location.pathname}${location.search}`, routes, guid)
    );
  }, [guid, location.pathname, location.search, routes]);

  return (
    <Tabs index={activeTab} {...rest}>
      <TabList mt="auto">
        {routes.map((route) => {
          return (
            <Tab
              key={route.path}
              data-testid={`${route.name}-tab`}
              onClick={() => {
                const tabUrl = new UrlPattern(route.path).stringify(
                  typeof guid === 'object' ? guid : { guid }
                );
                if (location.pathname !== tabUrl) {
                  navigate({ pathname: tabUrl, search: location.search });
                }
              }}
            >
              {route.name}
              {counts && counts[route.name] > 0 && (
                <Text color="B.0" fontSize="inherit" fontWeight="inherit">
                  &nbsp;({counts[route.name]})
                </Text>
              )}
            </Tab>
          );
        })}
      </TabList>
    </Tabs>
  );
};
